<!-- main content -->
<p-messages [value]="messages" styleClass="popup-alert"></p-messages>
<div class="sticky-table-container">
    <p-table stripedRows [value]="items"
        dataKey="id"
        [rowTrackBy]="rowTrackBy"
        #dtIndirectRateStructure
        [style]="{ 'min-width': '100%' }"
        editMode="row"
        [(selection)]="selected"
    >
        <ng-template pTemplate="emptymessage">
            <tr>
                <td
                    [attr.colspan]="showAdjustments ? 7 : 6"
                    style="text-align: center"
                >
                    <div class="tabulator-placeholder">
                        <span> No Data Available </span>
                    </div>
                </td>
            </tr>
        </ng-template>
        <ng-template #header let-item>
            <tr>
                <!-- Edit -->
                <th class="edit-cell"></th>
                <!-- status-->
                <th class="status-cell">
                    <i
                        class="pi pi-exclamation-circle"
                        title="Status"
                    ></i>
                </th>
                <!-- Rate Type -->
                <th pSortableColumn="Calcshortdesc">
                    Indirect Rates
                            {{
                                FiscalYearEndDate
                                    ? 'for FY Ending ' + FiscalYearEndDate
                                    : ''
                            }}
                    <p-sortIcon
                        pSortableColumn="Calcshortdesc"
                        field="Calcshortdesc"
                        ariaLabel="Activate to sort"
                        ariaLabelDesc="Activate to sort in descending order"
                        ariaLabelAsc="Activate to sort in ascending order"
                    ></p-sortIcon>
                    <p-columnFilter field="Calctype" matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false" class="ml-auto">
                        <ng-template #filter let-value let-filter="filterCallback">
                            <p-multiSelect
                                defaultLabel="Filter"
                                maxSelectedLabels="1"
                                appendTo="body"
                                [options]="rates"
                                [filter]="true"
                                styleClass="w-full"
                                [ngModel]="value"
                                (ngModelChange)="filter($event)"
                            ></p-multiSelect>
                        </ng-template>
                    </p-columnFilter>
                </th>
                <!-- Rate (percent) -->
                <th pSortableColumn="PayrollDisplay">
                    Rate (percent)
                    <p-sortIcon
                        pSortableColumn="PayrollDisplay"
                        field="PayrollDisplay"
                        ariaLabel="Activate to sort"
                        ariaLabelDesc="Activate to sort in descending order"
                        ariaLabelAsc="Activate to sort in ascending order"
                    ></p-sortIcon>
                </th>
                <!-- Last Update -->
                <th pSortableColumn="AccountName">
                    Last Update
                    <p-sortIcon
                        pSortableColumn="AccountName"
                        field="AccountName"
                        ariaLabel="Activate to sort"
                        ariaLabelDesc="Activate to sort in descending order"
                        ariaLabelAsc="Activate to sort in ascending order"
                    ></p-sortIcon>
                </th>
                <!-- Adjusted Date -->
                <th *ngIf="showAdjustments">
                    FY Adjusted Date
                </th>
                <!-- Delete -->
                <th class="delete-cell"></th>
            </tr>
        </ng-template>
        <ng-template
            #body
            let-item
            let-edit="editing"
            let-rowData
        >
            <tr
                [pSelectableRow]="item"
                [pEditableRow]="item"
                data-id="row-{{ item?.id }}"
                [ngClass]="{
                    'ui-editing-row': editing && editing?.id === rowData?.id
                }"
            >
                <!-- Edit -->
                <td class="edit-cell">
                    <!-- for a new row -->
                    <button
                        title="Add"
                        *ngIf="item?.id === 'add' && !edit && !disabled"
                        pButton
                        type="button"
                        pInitEditableRow
                        icon="pi pi-plus"
                        class="p-button-rounded p-button-text p-button-success"
                        (click)="onRowEditInit(item)"
                    ></button>
                    <button
                        title="Edit"
                        *ngIf="
                            !edit &&
                            (!editing?.id || editing?.id === item?.id) &&
                            !disabled &&
                            item?.id !== 'add'
                        "
                        pButton
                        type="button"
                        pInitEditableRow
                        icon="pi pi-pencil"
                        class="p-button-rounded p-button-text"
                        (click)="onRowEditInit(item)"
                        title="Edit"
                    ></button>
                    <button
                        title="Save"
                        *ngIf="edit"
                        pButton
                        type="button"
                        pSaveEditableRow
                        icon="pi pi-check"
                        class="p-button-rounded p-button-text p-button-success"
                        (click)="onRowEditSave(item)"
                    ></button>
                    <button
                        title="Cancel"
                        *ngIf="edit"
                        pButton
                        type="button"
                        pCancelEditableRow
                        icon="pi pi-times"
                        class="p-button-rounded p-button-text p-button-danger"
                        (click)="onRowEditCancel(item)"
                    ></button>
                </td>
                <!-- Status-->
                <td class="status-cell">
                    <div (click)="onStatusClick(item)" class="status-cell">
                        <ef-status-icon
                            [status]="item?.Status?.StatusCode"
                            [message]="item?.Status?.Message"
                        ></ef-status-icon>
                    </div>
                </td>
                <!-- Rate Type -->
                <td class="disabled">
                    <p-cellEditor>
                        <ng-template
                            *ngIf="!item?.IsReadOnly && item?.id === 'add'"
                            pTemplate="input"
                        >
                            <p-select
                                [autoDisplayFirst]="false"
                                [style]="{ width: '100%' }"
                                [options]="filteredRates | orderBy: 'label'"
                                appendTo="body"
                                [(ngModel)]="item.Calctype"
                                defaultLabel="Rate Type"
                                [filter]="true"
                            ></p-select>
                        </ng-template>
                        <ng-template
                            *ngIf="item?.IsReadOnly || item?.id !== 'add'"
                            pTemplate="input"
                        >
                            {{ item?.Calcshortdesc }}
                        </ng-template>
                        <ng-template pTemplate="output">
                            {{ item?.Calcshortdesc }}
                        </ng-template>
                    </p-cellEditor>
                </td>
                <!-- Rate (percent) -->
                <td>
                    <p-cellEditor>
                        <ng-template
                            *ngIf="!item?.IsReadOnly"
                            pTemplate="input"
                        >
                            <input
                                title="Rate Percent"
                                pInputText
                                [(ngModel)]="item.Ratepercent"
                            />
                        </ng-template>
                        <ng-template *ngIf="item?.IsReadOnly" pTemplate="input">
                            {{ item?.Ratepercent?.toFixed(2) }}
                        </ng-template>
                        <ng-template pTemplate="output">
                            {{ item?.Ratepercent?.toFixed(2) }}
                        </ng-template>
                    </p-cellEditor>
                </td>
                <!-- Last Update-->
                <td class="disabled">
                    {{
                        moment(
                            item?.Maintdate ? item.Maintdate : null
                        ).isValid()
                            ? moment(item?.Maintdate).format('MM/DD/YYYY')
                            : ''
                    }}
                </td>
                <!-- Adjusted Date -->
                <td *ngIf="showAdjustments">
                    {{
                        moment(
                            item?.FYadjusted ? item.FYadjusted : null
                        ).isValid()
                            ? moment(item?.FYadjusted).format('MM/DD/YYYY')
                            : ''
                    }}
                </td>
                <!-- Delete -->
                <td class="delete-cell">
                    <button
                        title="Delete"
                        *ngIf="item?.id !== 'add' && !editing"
                        pButton
                        type="button"
                        icon="pi pi-trash"
                        class="p-button-rounded p-button-text p-button-danger"
                        (click)="onRowEditDelete(item)"
                        style="font-size: 0.65rem"
                    ></button>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
